export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13097.d461bab9.jpg";